/* eslint-disable */
// import React, { useState, useEffect } from 'react';
// import './styles/Slider.css';

// const AutoInfiniteSlider = ({
//   images,
//   setDurationId,
//   setPlanName,
//   setShow,
//   setProdId,
//   setPrice,
//   PlanForUnlockMe,
//   callOffers,
//   productsForNew,
//   setproductsForNew,
//   SelectedCategory,
//   setSelectedCategory,
//   SelectedNAme,
//   setSelectedNAme,
//   HasSubCategory,
//   setHasSubCategory,
//   SubCat,
//   setSubCat,
//   IsValid
// }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const intervalId = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//     }, 6000);

//     // Clear the interval when the component unmounts
//     return () => clearInterval(intervalId);
//   }, [images.length]);

//   const DNA = productsForNew.find((item) => item.category.toLowerCase() === 'dna test');
//   const Nutrition = productsForNew.find((item) => item.category.toLowerCase() === 'nutrition');
//   const Blood = productsForNew.find((item) => item.category.toLowerCase() === 'wellness store');
//   const findThyroid = Blood?.sub_categories.find(
//     (item) => item.sub_category.toLowerCase() === 'thyroid'
//   );
//   const findchole = Blood?.sub_categories.find(
//     (item) => item.sub_category.toLowerCase() === 'cholesterol'
//   );
//   const finddiab = Blood?.sub_categories.find(
//     (item) => item?.sub_category.toLowerCase() === 'diabetes'
//   );

//   return (
//     <div className="abso">
//       <a href="./#product">
//         <div
//           className="slider-container"
//           // onClick={() => {
//           //   const divide = PlanForUnlockMe[0];
//           //   setDurationId(divide.duration_id);
//           //   setPlanName(divide.package_title);
//           //   setShow(true);
//           //   setProdId(divide.package_id);
//           //   setPrice(divide.special_price);
//           //   callOffers();
//           // }}
//         >
//           <div
//             className="slider-wrapper"
//             style={{ transform: `translateX(${-currentIndex * 100}%)` }}>
//             {images.map((image, index) => (
//               <div key={index} className="slider-item">
//                 <img
//                   src={image.link}
//                   alt={`Slide ${index}`}
//                   style={{ width: '-webkit-fill-available' }}
//                   onClick={() => {
//                     if (index === 0) {
//                       // setSelectedCategory(Blood.category_id);
//                       // setSelectedNAme(Blood.category);
//                       // setHasSubCategory(Blood.has_sub_category);
//                       // setSubCat(findchole.sub_category_id);
//                       setSelectedCategory(DNA.category_id);
//                       setSelectedNAme(DNA.category)
//                     }
//                     if (index === 1) {
//                       setSelectedCategory(Blood.category_id);
//                       setSelectedNAme(Blood.category);
//                       setHasSubCategory(Blood.has_sub_category);
//                       setSubCat(finddiab.sub_category_id);
//                     }
//                     if (index === 2 || index === 3) {
//                       setSelectedCategory(Blood.category_id);
//                       setSelectedNAme(Blood.category);
//                       setHasSubCategory(Blood.has_sub_category);
//                       setSubCat(findThyroid.sub_category_id);
//                     }
//                   }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </a>
//       <div className="icon-container">
//         {images.map((_, index) => (
//           <div
//             key={index}
//             style={{ cursor: 'pointer' }}
//             onClick={() => setCurrentIndex(index)}
//             className={`icon ${currentIndex === index ? 'active' : ''}`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AutoInfiniteSlider;

/* eslint-disable */
import React, { useState, useEffect } from "react";
import "./styles/Slider.css";
import moment from "moment-timezone";

const AutoInfiniteSlider = ({
  images = [],
  setDurationId,
  setPlanName,
  setShow,
  setProdId,
  setPrice,
  PlanForUnlockMe,
  callOffers,
  productsForNew = [],
  setproductsForNew,
  SelectedCategory,
  setSelectedCategory,
  SelectedNAme,
  setSelectedNAme,
  HasSubCategory,
  setHasSubCategory,
  SubCat,
  setSubCat,
  IsValid,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  /* ✅ Auto slide ONLY when more than 1 image */
  useEffect(() => {
    if (!images || images.length <= 1) return;

    const intervalId = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 6000);

    return () => clearInterval(intervalId);
  }, [images]);

  /* ✅ Safe category lookups */
  const DNA = productsForNew.find(
    (item) => item?.category?.toLowerCase() === "dna test"
  );

  const Blood = productsForNew.find(
    (item) => item?.category?.toLowerCase() === "wellness store"
  );

  const findThyroid = Blood?.sub_categories?.find(
    (item) => item?.sub_category?.toLowerCase() === "thyroid"
  );

  const finddiab = Blood?.sub_categories.find(
    (item) => item?.sub_category.toLowerCase() === "diabetes"
  );

  const timezone = "Asia/Kolkata";

  const today = moment.tz(timezone).startOf("day");
  const secondJuly = moment
    .tz(timezone)
    .month(6) // July (0-based)
    .date(1)
    .startOf("day");

  const tweleJuly = moment
    .tz(timezone)
    .month(6) // July (0-based)
    .date(12)
    .startOf("day");

  const isAfter2ndJuly = today.isAfter(secondJuly);
  const isBefore12thJuly = today.isBefore(tweleJuly);

  console.log("Is After 2nd July 2026", isAfter2ndJuly);
  console.log("Is Before 12th July 2026", isBefore12thJuly);

  return (
    <div className="abso">
      <a href="./#product">
        <div className="slider-container">
          <div
            className="slider-wrapper"
            style={{
              transform:
                images.length > 1
                  ? `translateX(${-currentIndex * 100}%)`
                  : "translateX(0%)",
              transition:
                images.length > 1 ? "transform 0.6s ease-in-out" : "none",
            }}
          >
            {images.map((image, index) => (
              <div key={index} className="slider-item">
                <img
                  src={image?.link}
                  alt={`Slide ${index}`}
                  style={{ width: "-webkit-fill-available" }}
                  onClick={() => {
                    if (index === 0) {
                      if (isAfter2ndJuly && isBefore12thJuly) {
                        setSelectedCategory(DNA.category_id);
                        setSelectedNAme(DNA.category);
                      } else {
                        setSelectedCategory(Blood.category_id);
                        setSelectedNAme(Blood.category);
                        setHasSubCategory(Blood.has_sub_category);
                        //setSubCat(findchole.sub_category_id);
                      }
                    }
                    if (index === 1) {
                      setSelectedCategory(Blood.category_id);
                      setSelectedNAme(Blood.category);
                      setHasSubCategory(Blood.has_sub_category);
                      setSubCat(finddiab.sub_category_id);
                    }
                    if (index === 2 || index === 3) {
                      setSelectedCategory(Blood.category_id);
                      setSelectedNAme(Blood.category);
                      setHasSubCategory(Blood.has_sub_category);
                      setSubCat(findThyroid.sub_category_id);
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </a>

      {/* ✅ Dots ONLY when more than 1 image */}
      {images.length > 1 && (
        <div className="icon-container">
          {images.map((_, index) => (
            <div
              key={index}
              className={`icon ${currentIndex === index ? "active" : ""}`}
              style={{ cursor: "pointer" }}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AutoInfiniteSlider;
